import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ka',
    fullName: 'Georgian',
    nativeName: 'Ქართული',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "რაღაც საოცარი მოდის",
    landing_subtitle: "ArgVoid არის აპლიკაციებისა და თამაშების განვითარების სტუდია. თვალყური ადევნეთ, მალე ახალი ამბები გველის!",
    select_language: "აირჩიეთ ენა",
    search_placeholder: "ენების ძიება...",
    terms_title: "მომსახურების პირობები",
    policy_title: "კონფიდენციალურობის პოლიტიკა",
    cookies_title: "ქუქიების პოლიტიკა",
    terms_content: `
        <strong>1. პირობების მიღება</strong><br>
        ArgVoid-ზე წვდომით მიიღება მომსახურების ეს პირობები. თუ ეს პირობები არ არის შეთანხმებული, სერვისი არ უნდა იქნას გამოყენებული.<br><br>

        <strong>2. პლატფორმის გამოყენება</strong><br>
        ArgVoid და მისი აპლიკაციები მოცემულია "როგორც არის" საინფორმაციო და შემოქმედებითი მიზნებისთვის. სერვისი უნდა იქნას გამოყენებული მხოლოდ კანონიერი მიზნებისთვის.<br><br>

        <strong>3. აკრძალული ქცევა</strong><br>
        კატეგორიულად აკრძალულია საიტის დაუცველობის, სპამის ან ინფრასტრუქტურაზე არაავტორიზებული წვდომის მცდელობა.<br><br>

        <strong>4. პასუხისმგებლობის უარყოფა</strong><br>
        პლატფორმა და სერვისები შეიძლება შეიცვალოს ნებისმიერ დროს გაფრთხილების გარეშე. არავითარი გარანტია არ არის გაცემული სერვისის მუშაობის დროზე ან ხელმისაწვდომობასთან დაკავშირებით.
    `,
    policy_content: `
        <strong>1. ინფორმაციის კოლექცია</strong><br>
        ამ დროისთვის პლატფორმა არ საჭიროებს მომხმარებლის ავტორიზაციას ან ანგარიშის შექმნას. არავითარი პირადი საიდენტიფიკაციო ინფორმაცია (როგორიცაა სახელები ან ელფოსტის მისამართები) აქტიურად არ გროვდება ვიზიტორებისგან.<br><br>

        <strong>2. გამოიყენეთ Data</strong><br>
        ძირითადი, ანონიმური ანალიტიკა შეიძლება შეგროვდეს საიტის ტრაფიკის გასაგებად და აპლიკაციების გასაუმჯობესებლად. ეს მონაცემები არ არის დაკავშირებული ინდივიდუალური მომხმარებლის იდენტიფიკაციებთან.<br><br>

        <strong>3. მესამე მხარის სერვისები</strong><br>
        მესამე მხარის პროვაიდერები შეიძლება გამოყენებულ იქნას ჰოსტინგისა და ანალიტიკური სერვისებისთვის. ამ შესაბამისი პროვაიდერების კონფიდენციალურობის პრაქტიკა მართავს ანონიმურ მონაცემებს დამუშავებულ მათ ინფრასტრუქტურაზე.<br><br>

        <strong>4. მონაცემთა უსაფრთხოება</strong><br>
        გონივრული უსაფრთხოების ზომები ხორციელდება პლატფორმის დასაცავად. თუმცა, ინტერნეტით გადაცემის არც ერთი მეთოდი არ არის სრულიად უსაფრთხო.<br><br>
    `,
    cookies_content: `
        <strong>1. რა არის ქუქი-ფაილები და ლოკალური საცავი?</strong><br>
        ქუქი-ფაილები და ბრაუზერის ლოკალური საცავი არის პატარა მონაცემთა ფაილები, რომლებიც ინახება მოწყობილობაზე, რათა დაიმახსოვროთ კონფიგურაციის პარამეტრები ვიზიტებში.<br><br>

        <strong>2. გამოყენების მიზანი</strong><br>
        ბრაუზერი LocalStorage გამოიყენება მკაცრად კონფიგურაციის პარამეტრების შესანახად, როგორიცაა: <br>
        - ენის პრეფერენციები<br>
        - მომხმარებლის ინტერფეისის კონფიგურაცია (მაგ. განლაგება ან თემის პარამეტრები) <br>
        - დროებითი განაცხადის ქეში<br><br>

        <strong>3. არ არის Tracking</strong><br>
        ქუქი-ფაილები და ადგილობრივი მეხსიერება არ გამოიყენება სარეკლამო ან მესამე მხარის თვალთვალის მიზნებისთვის. ყველა შენახული მონაცემი მკაცრად არის პლატფორმის ძირითადი ფუნქციონირებისთვის.<br><br>

        <strong>4. Control</strong><br>
        ბრაუზერის მონაცემების გასუფთავება შესაძლებელია ნებისმიერ დროს ბრაუზერის პარამეტრების მეშვეობით, რაც აღადგენს ნებისმიერ ადგილობრივ კონფიგურაციას.
    `,
    cookie_consent_text: "ჩვენ ვიყენებთ ძირითად ქუქი-ფაილებს ვებსაიტის სწორად ფუნქციონირების უზრუნველსაყოფად, როგორიცაა თქვენი სესიის აქტიური შენარჩუნება, თქვენი ენის უპირატესობის შენახვა და სხვა მორგებული კონფიგურაციები.",
    read_policy: "წაიკითხეთ ქუქიების პოლიტიკა",
    support_title: "დაუკავშირდით მხარდაჭერას",
    support_subject_label: "საგანი",
    support_message_label: "შეტყობინება",
    support_submit_button: "გაგზავნეთ შეტყობინება",
    support_hint: "შენიშვნა: ეს გახსნის თქვენს ნაგულისხმევ ელ. აპლიკაციას შეტყობინების გასაგზავნად.",
    support_success_msg: "იხსნება თქვენი ელფოსტის აპლიკაცია...",
    support_error_msg: "შეტყობინების გაგზავნა ვერ მოხერხდა. გთხოვთ, სცადოთ მოგვიანებით.",
    explorer_title: "მკვლევარი",
    history_title: "ისტორია",
    animation_title: "ანიმაცია",
    config_title: "კონფიგურაცია",
    tool_mouse: "აირჩიეთ (Ctrl+M)",
    tool_brush: "ფუნჯი (Ctrl+B)",
    tool_brush_mode: "გადართვის რეჟიმი (მყარი/გასუფთავებული)",
    tool_eraser: "საშლელი (Ctrl+E)",
    tool_brush_size: "დაარეგულირეთ ფუნჯის ზომა",
    tool_bucket: "შევსება (Ctrl+F)",
    tool_eyedropper: "თვალის სათვალე",
    tool_grid: "ბადე (Ctrl+Shift+B)",
    tool_rotate: "როტაცია (Ctrl+Shift+R)",
    tool_flip_h: "გადაატრიალეთ H (Ctrl+Shift+H)",
    tool_flip_v: "გადაბრუნება V (Ctrl+Shift+V)",
    tool_transpose: "ტრანსპონირება (Ctrl+Shift+T)",
    label_width: "სიგანე",
    label_height: "სიმაღლე",
    label_frames: "ჩარჩოების რაოდენობა",
    label_animation: "ანიმაციის სტილი",
    label_background_color: "ფონის ფერი",
    label_interval: "ინტერვალი",
    tool_anim_config: "ანიმაციის კონფიგურაცია",
    label_new_width: "ახალი სიგანე",
    label_new_height: "ახალი სიმაღლე",
    label_apply: "მიმართვა",
    label_colors: "ფერები",
    label_size: "ზომა",
    label_tolerance: "ტოლერანტობა",
    val_horizontal: "ჰორიზონტალური",
    val_vertical: "ვერტიკალური",
    val_sequence: "თანმიმდევრობა",
    val_bounce: "Bounce",
    val_random: "შემთხვევითი",
    val_solid: "მყარი",
    val_clear: "წმინდა",
    action_add_sheet: "ახალი ფურცელი",
    action_import: "იმპორტი",
    action_export: "ექსპორტი",
    action_sort_projects: "დალაგება",
    sort_date_old: "უძველესი პირველი",
    sort_date_new: "უახლესი პირველი",
    sort_name_az: "სახელი (A-Z)",
    sort_name_za: "სახელი (Z-A)",
    action_new_sprite: "ახალი სპრაიტი",
    action_new_project: "ახალი პროექტი",
    modal_save_all_title: "შეინახეთ ყველა ცვლილება",
    modal_save_all_desc: "აირჩიეთ აქტივები შესანახად:",
    modal_save_selected: "არჩეული შენახვა",
    action_saved: "შენახულია",
    modal_create_sprite_title: "შექმენით ახალი Sprite",
    modal_create_project_title: "შექმენით ახალი პროექტი",
    modal_add_sheet_title: "ახალი ფურცლის დამატება",
    modal_rename_sheet_title: "ფურცლის გადარქმევა",
    modal_rename_sprite_title: "Sprite-ის გადარქმევა",
    modal_delete_sprite_title: "წაშალე Sprite",
    modal_delete_project_title: "პროექტის წაშლა",
    modal_delete_sheet_title: "ფურცლის წაშლა",
    placeholder_sprite_name: "სახელი",
    placeholder_project_name: "სახელი",
    placeholder_sheet_name: "სახელი",
    placeholder_new_name: "ახალი სახელი",
    action_create: "შექმნა",
    action_add: "დამატება",
    action_rename: "გადარქმევა",
    action_duplicate: "დუბლიკატი",
    action_delete: "წაშლა",
    action_cancel: "გაუქმება",
    confirm_delete_sprite: "დარწმუნებული ხართ, რომ გსურთ წაშალოთ ეს sprite?",
    confirm_delete_project: "დარწმუნებული ხართ, რომ გსურთ ამ პროექტის წაშლა? ყველა სპრიტი წაიშლება.",
    confirm_delete_sheet: "დარწმუნებული ხართ, რომ გსურთ ამ ფურცლის წაშლა?",
    err_select_sprite: "გთხოვთ, ჯერ შეარჩიოთ სპრაიტი.",
    err_select_project: "გთხოვთ, ჯერ აირჩიოთ პროექტი.",
    err_name_empty: "სახელი არ შეიძლება იყოს ცარიელი.",
    err_sprite_exists: "ამ სახელით სპრაიტი უკვე არსებობს.",
    err_project_exists: "ამ სახელწოდების პროექტი უკვე არსებობს.",
    err_no_content: "კონტენტი არ არის შესანახი.",
    err_no_changes: "შესანახად ცვლილებები არ არის.",
    err_delete_last_sheet: "ბოლო ფურცლის წაშლა შეუძლებელია.",
    err_extract_frames: "ჩარჩოების ამოღება ვერ მოხერხდა.",
    err_indexeddb: "ადგილობრივად შენახვა ვერ მოხერხდა. შესაძლოა თქვენს ბრაუზერს არ ჰქონდეს IndexedDB მხარდაჭერა.",
    msg_upload_success: "ატვირთვა წარმატებით დასრულდა: {0}",
    msg_upload_failed: "ატვირთვა ვერ მოხერხდა: {0}",
    msg_save_success: "წარმატებული შენახვა.",
    msg_saving: "მიმდინარეობს შენახვა...",
    msg_multi_save_result: "შენახულია {0} აქტივი. {1} წარუმატებლობა.",
    menu_title: "მენიუ",
    menu_save: "შენახვა",
    menu_save_all: "შეინახეთ ყველა",
    menu_support: "დაუკავშირდით მხარდაჭერას",
    label_local_storage: "ლოკალური საცავი",
    label_sign_in: "შესვლა",
    modal_export_title: "Sprite-ის ექსპორტი",
    label_filename: "ფაილის სახელი",
    label_format: "ფორმატი",
    action_export_confirm: "ექსპორტი",
};

export default translations;
